export default "__VITE_ASSET__BaHW2YFk__"